define([
    'jquery',
    '../reviews',
    '../carousel_mobile',
    '../console',
    '../globals'
], function ($, reviews, carouselMobile, console, globals) {
    'use strict';

    const _template = 'home';
    const tm = require('../vendor/gsap/gsap').TweenMax;
    const videoPlayer = require('../video');

    const PhotoSwipeLightbox = require('../vendor/photoswipe/photoswipe-lightbox.umd.min');
    const PhotoSwipe = require('../vendor/photoswipe/photoswipe.umd.min');
    let myGallery;

    function enableEventHandlers() {
        videoPlayer.activate();
        reviews.truncate();

        if ($('.js-gallery_images').length) {
            myGallery = new PhotoSwipeLightbox({
                gallery: '.js-gallery_images',
                children: 'a',
                pswpModule: PhotoSwipe,
                bgOpacity: 0.7,
                // spacing: 0.5, // 50% of viewport width
                // closeOnVerticalDrag: false,
                // showAnimationDuration: 1000,
                // hideAnimationDuration: 1000,
            });
            myGallery.init();

            carouselMobile.init();
        }
    }

    function disableEventHandler() {
        videoPlayer.deactivate();
        reviews.detachEventHandlers();

        if (myGallery && myGallery.destroy === 'function') {
            myGallery.destroy();
        }
    }

    const animateIn = function (callback) {
        if ($('.viewport').data('template') !== _template) {
            return false;
        }

        enableEventHandlers();

        tm.to($('.page-row-expanded'), 0.3, {
            css: {opacity: 1}, onComplete: function () {
                //tm.to($('.footer'), 1.2, {ease: Power1.easeOut, css: {opacity: 1}, delay: 1});
                if (callback && typeof (callback) === "function") {
                    return (callback());
                }
            }
        });
    };

    const animateOut = function (callback) {
        if ($('.viewport').data('template') !== _template) {
            return false;
        }

        disableEventHandler();

        tm.to($('.page-row-expanded'), 0.3, {
            css: {opacity: 0}, onComplete: function () {
                if (callback && typeof (callback) === "function") {
                    return (callback());
                }
            }
        });
    };

    return {
        animateIn: animateIn,
        animateOut: animateOut
    }
});